import Accordion from "@/components/Accordion";
import React from "react";
import { WhatsApp } from "./WhatsApp";
import { Messenger } from "./Messenger";
import { Sms } from "./Sms";
import { Phone } from "./Phone";
import ChatWindowPreview from "../../Preview/ChatWindowPreview";
import { ChatWindow } from "../../types";

interface Props {
  workingChatWindow: ChatWindow;
  setWorkingChatWindow: (chatWindow: ChatWindow) => void;
}

export default function Channels(props: Props) {
  const [selectedScreen, setSelectedScreen] = React.useState("WhatsApp");

  const previewScreens = [
    {
      label: "Connect via WhatsApp",
      action: () => setSelectedScreen("WhatsApp"),
      name: "WhatsApp"
    },
    {
      label: "Connect via Messenger",
      action: () => setSelectedScreen("Facebook"),
      name: "Facebook"
    },
    {
      label: "Connect via SMS",
      action: () => setSelectedScreen("SMS"),
      name: "SMS"
    }
  ];

  return (
    <div className="panel flex bg-white rounded-2xl shadow-md w-full border">
      <div className="p-6 border-r border-slate-300 w-full">
        <div className="text-lg font-medium mb-2">Channels</div>
        <div className="text-sm font-normal text-slate-600 mb-4">
          Customize which channels are available to the user
        </div>
        <div className="overflow-auto">
          <Accordion>
            <WhatsApp
              onExpanded={() => setSelectedScreen("WhatsApp")}
              workingChatWindow={props.workingChatWindow}
              setWorkingChatWindow={props.setWorkingChatWindow}
            />
            <Messenger
              onExpanded={() => setSelectedScreen("Facebook")}
              workingChatWindow={props.workingChatWindow}
              setWorkingChatWindow={props.setWorkingChatWindow}
            />
            <Sms
              onExpanded={() => setSelectedScreen("SMS")}
              workingChatWindow={props.workingChatWindow}
              setWorkingChatWindow={props.setWorkingChatWindow}
            />
            {/* <Phone onExpanded={() => {}} /> */}
          </Accordion>
        </div>
      </div>
      <div className="w-full">
        <ChatWindowPreview
          chatWindow={props.workingChatWindow}
          previewScreens={previewScreens}
          selectedScreen={selectedScreen}
          setSelectedScreen={setSelectedScreen}
        />
      </div>
    </div>
  );
}
